/* eslint-disable */
import { GetterTree } from "vuex";
import { Channel } from "@/models/channel";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { ChannelState } from "@/types/channel";

const getters: GetterTree<ChannelState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Channel();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((channel) => Channel.toSelectItem(channel))
      : [];
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((channel) => {
          return channel.id == id;
        })
      : new Channel();
  },
};

export default getters;
